import React, { Component } from "react";
import { connect } from "react-redux";
import classes from "./RefundStatus.css";
import global from "../../../../../global.css";

class RefundStatus extends Component {
    state = {
        FakeBox: ['', '', '', '', '', '']
    }
    render() {
        return (
            <div className={classes.statusFather}>
                {
                    this.props.refundList
                        ? this.props.refundList.Static.map(item => {
                            return <div
                                key={item.Status}
                                onClick = {() => this.props.StatusFilter(item.Status)}
                                className={[classes.StatusBox, global.Responsive].join(" ")} >
                                <h3>{item.Title}</h3>
                                <span>{item.Count}</span>
                            </div>
                        })
                        : <div>
                            {
                                this.state.FakeBox.map((_ , i) => {
                                    return <div 
                                    key= {i}
                                        className={[classes.FakeStatusBox, global.Responsive].join(" ")} >
                                        <h3>.</h3>
                                        <span>.</span>
                                    </div>
                                })
                            }
                        </div>
                }
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        refundList: state.REFUND.refundList
    }
}

export default connect(mapStateToProps)(RefundStatus)

